import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import { ReactComponent as CloseIcon } from "../../assets/images/CloseIcon.svg";
import CircularProgress from "@mui/material/CircularProgress";
import "../../styles/ownerPartRequest.css";
import { ReactComponent as ButtonPlus } from "../../assets/images/ButtonPlus.svg";
import { ReactComponent as MatrixCriteria } from "../../assets/images/MatrixCriteria.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListItemText from "@mui/material/ListItemText";
import { httpRequest } from "../../api/httpRequests";
import Checkbox from "@mui/material/Checkbox";
import { ReactComponent as Info } from "../../assets/images/Info.svg";
import { automationHttpRequest } from "../../api/httpRequests";
import {
  Paper,
  Select,
  MenuItem,
  OutlinedInput,
  Divider,
  TextField,
  FormControlLabel,
  FormGroup,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Autocomplete,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import "../../styles/partCreation.css";
import { ConstructionRounded } from "@mui/icons-material";
import JustificationDialog from "../PartCreation/JustificationDialog";
import OwnerSubstitutionData from "./OwnerSubstitutionData";
import DecisionMatrixDataOwner from "./DecisionMatrixDataOwner";

const OwnerPartCreationDialog = ({
  partRequestNumber,
  open,
  dialogData,
  materialgroups,
  fetchPartRequestHistory,
  closeDialog,
  dialogLoading,
  attributeDetails,
  onRequestStatusUpdate,
  showSubmitOnly = false,
}) => {
  const [initialRender, setInitialRender] = useState(true);
  const [ownerComment, setOwnerComment] = React.useState("");
  const [dataModified, setDataModified] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [justificationOpen, setJustificationOpen] = useState(false);
  const [loadingReject, setLoadingReject] = React.useState(false);
  const [loadingRework, setLoadingRework] = React.useState(false);
  const [attributes, setAttributes] = useState([]);
  const [attributesObj, setAttributesObj] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [uomValues, setUOMValues] = useState({});
  const [attributeValue, setAttributeValue] = useState({});
  const [chipValues, setChipValues] = useState([]);
  const [initialChipValues, setInitialChipValues] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [uomValue, setUomValue] = useState({});
  const [updateAttributeValues, setUpdatedAttributeValues] = useState({});
  const [typeAttributeValue, setTypeAttributeValue] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [modifierSearch, setModifierSearch] = useState("");
  const [topAttribute, setTopAttribute] = useState([]);
  const [registeredAttribute, setRegisteredAttribute] = useState({});
  const [attributeTypeValue, setAttributeTypeValue] = useState({});
  const [totalUomValues, setTotalUomValues] = useState(0);
  const [vendorNames, setVendorNames] = useState([]);
  const [materialgroup, setMaterialgroup] = useState();
  const [materialGroupOptions, setMaterialGroupOptions] = useState([]);
  const [optionToShow, setOptionToShow] = useState([]);
  const [inputValues, setInputValues] = useState([""]);
  const [partDescriptionData, setPartDescriptionData] = useState({});
  const [abcIndicator, setAbcIndicator] = useState({
    abcIndicatorFutureValue: "A : Significant Material",
    abcIndicatorJustify: "",
  });
  const [modified, setModified] = useState(false);
  const [decisionData, setDecisionData] = useState({
    impact_score: 0,
    probability_score: "",
    stock_decision: "",
    stock_decision_comment: "",
  });
  const [minimumValue, setMinimumValue] = useState({
    minimumFutureValue: "",
    minimumValueJustify: "",
  });
  const [maximumValue, setMaximumValue] = useState({
    maximumFutureValue: "",
    maximumValueJustify: "",
  });
  const [criticalityIndicator, setCriticalityIndicator] = useState("");
  const [sloc, setSloc] = useState("4010");
  const [bin, setBin] = useState("");
  const [conversionValue, setConversionValue] = useState({
    order_unit: 1,
    base_unit: 1,
  });
  const [pirDataValue, setPirDataValue] = useState({
    vendor_account: "",
    supplier_part_number: "",
    lead_time_from_pir: "",
    base_uom: "EA",
    standard_price: "",
    order_uom: "EA",
    predticed_usage: "",
    justification_for_net_price_change: "",
  });
  const [checkPart, setCheckPart] = useState({
    manufacturer: "",
    manufacturing_part_number: "",
    supplier_part_number: "",
  });
  const [inputCount, setInputCount] = useState(1);
  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };
  const options = ["USD", "CAD", "EUR", "GBP", "JPY"];
  const leadTimeOptions = ["Days", "Months", "Years"];
  const uomOptions = [
    "DZ",
    "FT",
    "RL",
    "MIL",
    "M",
    "TH",
    "BOX",
    "DR",
    "BTE",
    "KG",
    "BAG",
    "L",
    "EA",
    "PAK",
    "PAC",
    "GLL",
    "PAA",
    "CS",
    "LB",
    "PAQ",
  ];
  const [currency, setCurrency] = useState("USD");
  const uomProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };
  const headingStyleAttribute = {
    fontSize: 13,
    fontFamily: "Verdana",
    fontWeight: "600",
    margin: "30px 0px 10px 0px",
  };
  // console.log("attributeValue", updateAttributeValues )

  const isInitialRender = useRef(true);

  //console.log(dialogData, attributeDetails);

  const [checkTableData, setCheckTableData] = useState([]);
  const [maxRows, setMaxRows] = useState(0);
  const [columnValues, setColumnValues] = useState();
  const [subStituLoading, setSubStituLoading] = useState(false);

  useEffect(() => {
    fetchSubstitutionData(dialogData?.clean_short_description);
  }, [dialogData]);

  const fetchSubstitutionData = async (val) => {
    setSubStituLoading(true);
    // const value = "bearing,ball,deep groove,20x42x12";
    try {
      const response = await httpRequest.post(
        "/search",
        {},
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
          },
          params: {
            search_str: val && val.replace(/[:,]/g, " ").trim(),
            limit: 10,
            page: 1,
            reset_filter: false,
          },
        },
      );
      if (response?.data?.success) {
        const column_values = Object.keys(response?.data?.table);
        const table_data = handleTableData(response?.data?.table);
        setColumnValues(column_values);
        setMaxRows(response?.data?.max_rows);
        setSubStituLoading(false);
        setCheckTableData(table_data);
      }
    } catch (error) {
      setSubStituLoading(false);
      console.error("Error:", error.message);
    }
  };

  const handleTableData = (value) => {
    const result = Object.keys(value[Object.keys(value)[0]]).map((i) =>
      Object.keys(value).reduce((obj, key) => {
        obj[key] = value[key][i];
        return obj;
      }, {}),
    );
    return result;
  };

  const handleConversionChange = (event) => {
    if (event?.target?.name === "conversionOrder") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          order_unit: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          order_unit: "",
        }));
      }
    }
    if (event?.target?.name === "conversionBase") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          base_unit: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setConversionValue((prevObject) => ({
          ...prevObject,
          base_unit: "",
        }));
      }
    }
  };

  useEffect(() => {
    const description = handlechipsValues(); // ✅ Use the function directly
    if (description) {
      setPartDescriptionData((prevValue) => ({
        ...prevValue,
        clean_short_description: description,
      }));
    }
  }, [chipValues, attributeValue, uomValue]);

  useEffect(() => {
    //fetchMaterialGroup();
    fetchVendorNames();
  }, [dialogData]);

  useEffect(() => {
    if (Array.isArray(materialgroups) && materialgroups.length > 0) {
      setMaterialGroupOptions(materialgroups);
    }
  }, [materialgroups]);

  useEffect(() => {
    const fetchMaterialGroup = async () => {
      try {
        const response = await automationHttpRequest.get(
          "/get_materialgroup/",
          {
            headers: {
              session_id: localStorage.getItem("session_id"),
              userEmail: localStorage.getItem("MRO_user_email"),
            },
          },
        );
        if (response?.data?.status) {
          setMaterialGroupOptions(response?.data?.data || []);
        }
      } catch (error) {
        toast.error("Unable to fetch material groups. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    };

    if (open && materialGroupOptions.length === 0) {
      fetchMaterialGroup();
    }
  }, [open, materialGroupOptions.length]);

  const fetchVendorNames = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.post(
        "/get_vendor_details/",
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        },
      );
      if (response?.data?.status) {
        setVendorNames(response?.data?.data);
        setOptionToShow(response?.data?.data.slice(0, 200));
        setFetching(false);
      }
    } catch (error) {
      console.error("Error fetching Vendors:", error);
    }
  };

  // const fetchMaterialGroup = async () => {
  //   setFetching(true);
  //   try {
  //     const response = await automationHttpRequest.get("/get_materialgroup/", {
  //       headers: {
  //         session_id: localStorage.getItem("session_id"),
  //         userEmail: localStorage.getItem("MRO_user_email"),
  //       },
  //     });
  //     if (response?.data?.status) {
  //       setMaterialgroups(response?.data?.data);
  //       setFetching(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching nouns:", error);
  //   }
  // };

  //   console.log(registeredAttribute,attributeTypeValue , attributeValue )

  useEffect(() => {
    // if (initialRender) {
    //     // Skip the effect on initial render
    //     setInitialRender(false);
    //     return;
    //   }
    if (isInitialRender.current) {
      // Skip the effect on initial render
      isInitialRender.current = false;
      return;
    }
    setTimeout(() => {
      if (
        pirDataValue?.standard_price <= 15 &&
        pirDataValue?.standard_price !== "" &&
        modified
      ) {
        setJustificationOpen(true);
      } else {
        setJustificationOpen(false);
      }
    }, 1000);
  }, [pirDataValue?.standard_price, modified]);

  const handleContinue = () => {
    setJustificationOpen(false);
    setModified(false);
  };

  const handleAddInput = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, ""]);
  };

  const renderStyledAttribute = (attributeName) => {
    const selectedAttr = attributesObj.find(
      (attr) => attr.attribute_name === attributeName,
    );
    const selectedOrder = selectedAttr?.attribute_order;

    const sameOrderAttrs = attributesObj.filter(
      (attr) => attr.attribute_order === selectedOrder,
    );

    const isGrouped = sameOrderAttrs.length > 1;

    if (!attributeName) return null;
    const firstChar = attributeName.charAt(0);
    const rest = attributeName.slice(1);

    return (
      <span>
        <span style={{ color: isGrouped ? "red" : "inherit" }}>
          {firstChar}
        </span>
        {rest}
      </span>
    );
  };

  React.useEffect(() => {
    if (attributeDetails) {
      const attributeData = attributeDetails;
      setTopAttribute(
        attributeData?.map((item) => item.attribute_name).slice(0, 4),
      );
      setAttributes(attributeData?.map((item) => item.attribute_name));
      const attributeValuesObject = {};
      attributeData?.forEach((item) => {
        attributeValuesObject[item.attribute_name] =
          item.attribute_values || [];
      });
      setAttributeValues(attributeValuesObject);

      //set attribute object
      setAttributesObj(
        attributeData.map((item) => ({
          attribute_name: item.attribute_name,
          group_order: item.group_order,
          attribute_order: item.attribute_order,
        })),
      );

      const uomValuesObject = {};
      attributeData?.forEach((item) => {
        uomValuesObject[item.attribute_name] = item.uom || [];
      });
      const typeValuesObject = {};
      attributeData?.forEach((item) => {
        typeValuesObject[item.attribute_name] = item.type || [];
      });
      setUOMValues(uomValuesObject);
      setTypeAttributeValue(typeValuesObject);
    }
  }, [attributeDetails]);
  React.useEffect(() => {
    if (!dialogData) return;

    let uomCount = 0;
    // Handle dynamic attributes
    Object.entries(dialogData?.attribute_data || {}).forEach(([key, value]) => {
      if (!attributes.includes(key)) return;

      const type = typeAttributeValue?.[key];
      if (type === "string") {
        setAttributeValue((prev) => ({ ...prev, [key]: value }));
        setAttributeTypeValue((prev) => ({ ...prev, [key]: value }));
        setRegisteredAttribute((prev) => ({ ...prev, [key]: ", " + value }));
      } else {
        const match = value.match(/^([\d\s\/.]+)\s*(.*)$/);
        let numericValue = value;
        let uomValue = "";

        if (match) {
          const possibleNumeric = match[1]?.trim();
          const possibleUOM = match[2]?.trim();

          if (possibleUOM.length >= 1 && possibleUOM.length <= 15) {
            numericValue = possibleNumeric;
            uomValue = possibleUOM;
            uomCount += 1;
          }
          setTotalUomValues(uomCount);
        }

        setAttributeValue((prev) => ({
          ...prev,
          [key]: numericValue,
          [key + "UOM"]: uomValue,
        }));

        setUomValue((prev) => ({
          ...prev,
          [key]: uomValue,
        }));

        setAttributeTypeValue((prev) => ({
          ...prev,
          [key]: numericValue,
          [key + "UOM"]: uomValue,
        }));

        setRegisteredAttribute((prev) => ({
          ...prev,
          [key]: ", " + numericValue,
          [key + "UOM"]: uomValue,
        }));
      }
    });

    // Other dialogData-based state updates
    setDecisionData({
      impact_score: dialogData?.impact_score,
      probability_score: dialogData?.probability_score,
      stock_decision: dialogData?.stock_decision,
      stock_decision_comment: dialogData?.stock_decision_comment,
    });

    setCheckPart({
      manufacturer: dialogData?.manufacturer,
      manufacturing_part_number: dialogData?.manufacturing_part_number,
      supplier_part_number: dialogData?.supplier_part_number,
    });

    setDataModified(false);

    const description = dialogData?.clean_short_description?.replace(
      /:/g,
      ":, ",
    );
    setChipValues(description);
    if (dialogData?.material_group) {
      const requestedGroup = String(dialogData.material_group)
        .trim()
        .toUpperCase();
      const matchedGroup = materialGroupOptions.find(
        (group) =>
          String(group?.material_group ?? "")
            .trim()
            .toUpperCase() === requestedGroup,
      );
      // Keep the saved group visible even when it is missing from the master list
      setMaterialgroup(
        matchedGroup || {
          material_group: dialogData.material_group,
          material_group_description:
            dialogData?.material_group_description || dialogData.material_group,
        },
      );
    }
    setInitialChipValues(
      `${dialogData?.noun_indentifier},${dialogData?.modifier}:`,
    );

    setInputCount(dialogData?.equipment_number_for_bom?.length || 0);
    setInputValues([...dialogData?.equipment_number_for_bom]);

    setPirDataValue({
      vendor_account: dialogData?.vendor_account,
      supplier_part_number: dialogData?.supplier_part_number,
      lead_time_from_pir: dialogData?.lead_time_from_pir?.split(" ")[0],
      base_uom: dialogData?.base_uom || "EA",
      standard_price: dialogData?.standard_price,
      order_unit_from_pir: dialogData?.order_unit_from_pir,
      base_unit: dialogData?.base_unit,
      order_uom: dialogData?.order_uom,
      predticed_usage: dialogData?.predticed_usage,
      justification_for_net_price_change:
        dialogData?.justification_for_net_price_change,
    });

    setConversionValue({
      base_unit: dialogData?.base_unit,
      order_unit: dialogData?.order_unit_from_pir,
    });

    setAbcIndicator({
      abcIndicatorJustify: dialogData?.future_abc_indicator,
      abcIndicatorFutureValue: dialogData?.ABC_indicator,
    });

    setMinimumValue({
      minimumValueJustify: dialogData?.future_minimum_stock_level,
      minimumFutureValue: dialogData?.minimum_stock_level,
    });

    setMaximumValue({
      maximumValueJustify: dialogData?.future_maximum_stock_level,
      maximumFutureValue: dialogData?.maximum_stock_level,
    });
    setSloc(dialogData?.storage_location);
    setBin(dialogData?.storage_bin);
    setCriticalityIndicator(dialogData?.critical_part);
    setOwnerComment(dialogData?.dataowner_extension_comment);
  }, [dialogData, attributeDetails, attributes, materialGroupOptions]);

  useEffect(() => {
    if (uomValue && Object.keys(uomValue).length) {
      const mappedObject = Object.fromEntries(
        Object.entries(attributeValue)
          .filter(([key, value]) => {
            return !key.includes("UOM");
          })
          .map(([key, value]) => {
            if (Object.keys(uomValue).includes(key)) {
              const result = uomValue[key];
              return [key, `${value} ${result}`];
            } else {
              return [key, value];
            }
          }),
      );
      setUpdatedAttributeValues(mappedObject);
    } else {
      setUpdatedAttributeValues(attributeValue);
    }
  }, [attributeValue, uomValue]);

  // console.log(pirDataValue, dialogData)

  // console.log(dialogData && Object.entries(dialogData?.attribute_data), typeAttributeValue, attributes)
  const handleChange = (event, attribute, value) => {
    handleAttributeChange(attribute, value, "select");
  };

  const countValidUomPairs = (data) => {
    let count = 0;

    for (const key in data) {
      if (key.endsWith("UOM")) {
        const baseKey = key.slice(0, -3); // Remove 'UOM'
        const uomValue = String(data[key]).trim();
        const baseValue = String(data[baseKey] || "").trim();

        if (uomValue && baseValue) {
          count++;
        }
      }
    }
    return count;
  };

  const handleAttributeChange = (attribute, value, type) => {
    setDataModified(true);
    let tempValue =
      value !== "" && value !== null && value !== undefined ? ", " + value : "";

    if (type === "UOMChange") {
      const selectedAttr = attributesObj.find(
        (attr) => attr.attribute_name === attribute,
      );
      if (!selectedAttr) return;

      const selectedOrder = selectedAttr.attribute_order;
      const newUom = value;
      const updatedAttributeTypeValue = { ...attributeTypeValue };
      //const currentUom = getSharedUomValue(attribute);

      //if (currentUom === value) return; // No need to update if value is the same

      const updatedUomValue = { ...uomValue };

      attributesObj.forEach((attr) => {
        const attrName = attr.attribute_name;
        const attrValue = attributeValue[attrName];
        if (
          attr.attribute_order === selectedOrder &&
          attrValue?.trim() // Only update if value is present
        ) {
          updatedUomValue[attrName] = newUom;
          updatedAttributeTypeValue[`${attrName}UOM`] = newUom;
        }
      });
      setUomValue(updatedUomValue);
      setAttributeTypeValue(updatedAttributeTypeValue);

      setTotalUomValues(countValidUomPairs(updatedAttributeTypeValue));
    }
    let attributeKey = attribute.toString();
    const attributeIndex = attributes.indexOf(attributeKey);

    if (attributeIndex === -1) {
      // Attribute not found in the attributes array
      return;
    }
    attributeKey = type === "UOMChange" ? attributeKey + "UOM" : attributeKey;
    if (type === "nonSelect") {
      const isFractionInProgress =
        /^\s*(\d+\s+)?\d*\/?\d*\s*$/.test(value) && !/\s\/\s*\d*/.test(value);
      const isDecimalInProgress = /^\d+(\.\d*)?$/.test(value);

      const isValid = /^[0-9,/.\\-\s]*$/.test(value);

      // Reject if both '.' and '/' are present (mixed format)
      if (value.includes(".") && value.includes("/")) {
        return;
      }

      const uomKey = `${attribute}UOM`;
      setAttributeValue((prev) => ({
        ...prev,
        [uomKey]: uomValue[attribute],
      }));
      setAttributeTypeValue((prev) => ({
        ...prev,
        [uomKey]: uomValue[attribute],
      }));

      // Reject if not a valid in-progress decimal or fraction
      if (!isFractionInProgress && !isDecimalInProgress && value !== "") {
        return;
      }

      // Reject if user tries to mix formats (e.g., "1.5/2" or "1/2.5")
      if (value.includes("/") && isDecimalInProgress) {
        return; // Mixed format not allowed
      }
      if (!isValid) return 0;
      const numericValue = parseInt(value, 10);
      tempValue =
        value !== "" && value !== null && value !== undefined
          ? ", " + value
          : "";
      if (isValid) {
        if (!isNaN(numericValue) && value !== "") {
          setAttributeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
          if (
            numericValue.toString().length === 1 &&
            (attributeValue[attributeKey]?.toString().length === 0 ||
              !attributeValue[attributeKey])
          ) {
            setTotalUomValues(totalUomValues + 1);
          }
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
          // ✅ NEW: Attach UOM to registeredAttribute if it exists
          const uom = uomValue[attribute];
          if (uom) {
            const updatedRegisteredAttribute = { ...registeredAttribute };
            updatedRegisteredAttribute[`${attribute}UOM`] = ", " + uom;
            setRegisteredAttribute(updatedRegisteredAttribute);
          }
        } else if (value === "" || value.length > 0) {
          delete attributeValue?.[attributeKey];
          delete attributeValue?.[attributeKey + "UOM"];
          setAttributeValue(attributeValue);
          if (value === "") {
            delete uomValue?.[attribute];
            delete attributeTypeValue?.[attribute + "UOM"];
            setUomValue(uomValue);
            setAttributeTypeValue(attributeTypeValue);
            if (totalUomValues) {
              setTotalUomValues(totalUomValues - 1);
            }
          }
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: "",
          }));
        }
      } else {
        setAttributeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attribute]: "",
        }));
        setAttributeTypeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attribute]: "",
        }));
      }
    } else {
      if (value && type !== "nonSelect") {
        setAttributeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
        setAttributeTypeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
      } else {
        delete attributeValue?.[attributeKey];
        delete attributeTypeValue?.[attributeKey];
        setAttributeValue(attributeValue);
        setAttributeTypeValue(attributeTypeValue);
      }
    }
    // Update chipValues and registeredAttribute
    const updatedChipValues = [...chipValues];
    const updatedRegisteredAttribute = { ...registeredAttribute };
    if (updatedRegisteredAttribute.hasOwnProperty(attributeKey)) {
      // Update existing attributeKey
      updatedChipValues[
        updatedChipValues.indexOf(updatedRegisteredAttribute[attributeKey])
      ] = tempValue;
      if (
        updatedRegisteredAttribute.hasOwnProperty(attributeKey + "UOM") &&
        tempValue === ""
      ) {
        updatedRegisteredAttribute[attributeKey + "UOM"] = ",";
      }
      updatedRegisteredAttribute[attributeKey] = tempValue;
    } else {
      // Add new attributeKey
      updatedChipValues.push(tempValue);
      updatedRegisteredAttribute[attributeKey] = tempValue;
    }
    setRegisteredAttribute(updatedRegisteredAttribute);
    const output = attributes.flatMap((key) => [key, `${key}UOM`]);
    const sortedObject = Object.fromEntries(
      output.map((key) => [key, updatedRegisteredAttribute[key] || ""]),
    );
    const outputString = Object.values(sortedObject)
      .filter((value) => value !== "")
      .join("");
    const chipContent = [...initialChipValues, outputString].join("");
    let totalChipsCharacters = chipContent.replace(/[\s,]/g, "");
    if (totalChipsCharacters.length < 40) {
      setChipValues(chipContent);
    }
  };

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#212F37",
    margin: "0px 20px",
  };

  const headingStyle = {
    fontWeight: "700",
  };

  const headingStyleComments = {
    fontWeight: "700",
    margin: "10px 10px 10px 0px",
  };

  const handleClose = () => {
    setOwnerComment("");
    setJustificationOpen(false);
    setModified(false);
    setAttributeValue({});
    setTotalUomValues(0);
    setAttributes([]);
    setAttributeValues({});
    setChipValues([]);
    setUomValue({});
    setAttributeTypeValue({});
    setInitialChipValues([]);
    setRegisteredAttribute({});
    closeDialog();
  };

  const handleVendorNameChange = (val) => {
    setPirDataValue((prevObject) => ({
      ...prevObject,
      vendor_account: val,
    }));
  };

  const handleRejectRequest = async () => {
    setLoadingReject(true);
    const values = {
      request_id: partRequestNumber,
      noun_indentifier: dialogData?.noun_indentifier,
      modifier: dialogData?.modifier,
      clean_short_description:
        partDescriptionData?.clean_short_description ||
        dialogData?.clean_short_description,
      attribute_data: updateAttributeValues,
      substitution_status: dialogData?.substitution_status,
      vendor_account: pirDataValue?.vendor_account,
      supplier_part_number: pirDataValue?.supplier_part_number,
      lead_time_from_pir: pirDataValue?.lead_time_from_pir + " Days",
      standard_price: pirDataValue?.standard_price,
      currency: currency,
      order_unit_from_pir: dialogData?.order_unit_from_pir || "",
      order_uom: pirDataValue?.order_uom,
      predticed_usage: pirDataValue?.predticed_usage,
      ABC_indicator:
        abcIndicator?.abcIndicatorFutureValue || dialogData?.ABC_indicator,
      critical_part: criticalityIndicator || dialogData?.critical_part || "",
      minimum_stock_level:
        minimumValue?.minimumFutureValue.toString() ||
        dialogData?.minimum_stock_level ||
        "",
      maximum_stock_level:
        maximumValue?.maximumFutureValue.toString() ||
        dialogData?.maximum_stock_level ||
        "",
      storage_location: sloc || dialogData?.storage_location,
      storage_bin: bin || dialogData?.storage_bin || "",
      equipment_number_for_bom:
        inputValues || dialogData?.equipment_number_for_bom,
      future_abc_indicator:
        abcIndicator?.abcIndicatorJustify ||
        dialogData?.future_abc_indicator ||
        "",
      future_maximum_stock_level:
        maximumValue?.maximumValueJustify ||
        dialogData?.future_maximum_stock_level ||
        "",
      future_minimum_stock_level:
        minimumValue?.minimumValueJustify ||
        dialogData?.future_minimum_stock_level ||
        "",
      dataowner_extension_comment: ownerComment,
      ...decisionData,
      ...checkPart,
    };
    try {
      const response = await automationHttpRequest.post(
        "/creation_reject/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoadingReject(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setJustificationOpen(false);
        setModified(false);
        setModified(false);
        setAttributeValue({});
        setTotalUomValues(0);
        setAttributes([]);
        setUomValue({});
        setAttributeTypeValue({});
        setAttributeValues({});
        setChipValues([]);
        setInitialChipValues([]);
        setRegisteredAttribute({});
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Rejected");
        closeDialog();
      }
    } catch (error) {
      setLoadingReject(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleReworkRequest = async () => {
    setLoadingRework(true);
    const values = {
      request_id: partRequestNumber,
      dataowner_extension_comment: ownerComment,
      plant_id: "0",
      plant_name: "GENERIC",
      submitted_by: localStorage.getItem("MRO_user_email") || "",
    };
    try {
      const response = await automationHttpRequest.post(
        "/create_material_rework/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoadingRework(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setJustificationOpen(false);
        setModified(false);
        setAttributeValue({});
        setTotalUomValues(0);
        setAttributes([]);
        setUomValue({});
        setAttributeTypeValue({});
        setAttributeValues({});
        setChipValues([]);
        setInitialChipValues([]);
        setRegisteredAttribute({});
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Rework");
        closeDialog();
      }
    } catch (error) {
      setLoadingRework(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };
  console.log(
    decisionData?.stock_decision_comment?.length,
    decisionData?.stock_decision_comment,
    "ASASAs",
  );
  const isStockDecisionValid =
    (decisionData?.stock_decision === "Non-Stock" &&
      decisionData?.stock_decision_comment?.length > 0) ||
    (decisionData?.stock_decision !== "Non-Stock" &&
      (!decisionData?.stock_decision_comment ||
        decisionData?.stock_decision_comment?.length === 0));
  const isEnabled =
    Object.keys(attributeValue || {}).length > 0 &&
    Object.keys(uomValue || {}).length === totalUomValues &&
    ownerComment?.trim()?.length > 0 &&
    isStockDecisionValid;

  const handleApproveRequest = async () => {
    if (!isEnabled || loading) return;

    const values = {
      request_id: partRequestNumber,
      noun_indentifier: dialogData?.noun_indentifier,
      modifier: dialogData?.modifier,
      material_group:
        materialgroup?.material_group || dialogData?.material_group,
      clean_short_description:
        partDescriptionData?.clean_short_description ||
        dialogData?.clean_short_description,
      attribute_data: updateAttributeValues,
      substitution_status: dialogData?.substitution_status,
      vendor_account: pirDataValue?.vendor_account,
      supplier_part_number: pirDataValue?.supplier_part_number,
      lead_time_from_pir: pirDataValue?.lead_time_from_pir + " Days",
      standard_price: pirDataValue?.standard_price,
      currency: currency,
      order_unit_from_pir: dialogData?.order_unit_from_pir || "",
      base_uom: pirDataValue?.base_uom,
      order_uom: dialogData?.order_uom,
      predticed_usage: pirDataValue?.predticed_usage.toString(),
      ABC_indicator:
        abcIndicator?.abcIndicatorFutureValue || dialogData?.ABC_indicator,
      critical_part: criticalityIndicator || dialogData?.critical_part || "",
      minimum_stock_level:
        minimumValue?.minimumFutureValue.toString() ||
        dialogData?.minimum_stock_level ||
        "",
      maximum_stock_level:
        maximumValue?.maximumFutureValue.toString() ||
        dialogData?.maximum_stock_level ||
        "",
      storage_location: sloc || dialogData?.storage_location,
      storage_bin: bin || dialogData?.storage_bin || "",
      equipment_number_for_bom:
        inputValues || dialogData?.equipment_number_for_bom,
      future_abc_indicator:
        abcIndicator?.abcIndicatorJustify ||
        dialogData?.future_abc_indicator ||
        "",
      future_maximum_stock_level:
        maximumValue?.maximumValueJustify ||
        dialogData?.future_maximum_stock_level ||
        "",
      future_minimum_stock_level:
        minimumValue?.minimumValueJustify ||
        dialogData?.future_minimum_stock_level ||
        "",
      dataowner_extension_comment: ownerComment,
      ...decisionData,
      ...checkPart,
    };
    try {
      setLoading(true);
      const response = await automationHttpRequest.post(
        "/creation_update/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoading(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setAttributeValue({});
        setTotalUomValues(0);
        setAttributes([]);
        setUomValue({});
        setAttributeTypeValue({});
        setAttributeValues({});
        setChipValues([]);
        setInitialChipValues([]);
        setRegisteredAttribute({});
        setJustificationOpen(false);
        setModified(false);
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Approved");
        closeDialog();
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleSubmitRequest = async () => {
    if (!isEnabled || loading) return;

    const values = {
      request_id: partRequestNumber,
      noun_indentifier: dialogData?.noun_indentifier,
      modifier: dialogData?.modifier,
      material_group:
        materialgroup?.material_group || dialogData?.material_group,
      clean_short_description:
        partDescriptionData?.clean_short_description ||
        dialogData?.clean_short_description,
      attribute_data: updateAttributeValues,
      substitution_status: dialogData?.substitution_status,
      vendor_account: pirDataValue?.vendor_account,
      supplier_part_number: pirDataValue?.supplier_part_number,
      lead_time_from_pir: pirDataValue?.lead_time_from_pir + " Days",
      standard_price: pirDataValue?.standard_price,
      currency: currency,
      order_unit_from_pir: dialogData?.order_unit_from_pir || "",
      base_uom: pirDataValue?.base_uom,
      order_uom: dialogData?.order_uom,
      predticed_usage: pirDataValue?.predticed_usage.toString(),
      ABC_indicator:
        abcIndicator?.abcIndicatorFutureValue || dialogData?.ABC_indicator,
      critical_part: criticalityIndicator || dialogData?.critical_part || "",
      minimum_stock_level:
        minimumValue?.minimumFutureValue.toString() ||
        dialogData?.minimum_stock_level ||
        "",
      maximum_stock_level:
        maximumValue?.maximumFutureValue.toString() ||
        dialogData?.maximum_stock_level ||
        "",
      storage_location: sloc || dialogData?.storage_location,
      storage_bin: bin || dialogData?.storage_bin || "",
      equipment_number_for_bom:
        inputValues || dialogData?.equipment_number_for_bom,
      future_abc_indicator:
        abcIndicator?.abcIndicatorJustify ||
        dialogData?.future_abc_indicator ||
        "",
      future_maximum_stock_level:
        maximumValue?.maximumValueJustify ||
        dialogData?.future_maximum_stock_level ||
        "",
      future_minimum_stock_level:
        minimumValue?.minimumValueJustify ||
        dialogData?.future_minimum_stock_level ||
        "",
      dataowner_extension_comment: ownerComment,
      ...decisionData,
      ...checkPart,
    };
    try {
      setLoading(true);
      const response = await automationHttpRequest.post(
        "/creation_rework_update/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoading(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setAttributeValue({});
        setTotalUomValues(0);
        setAttributes([]);
        setUomValue({});
        setAttributeTypeValue({});
        setAttributeValues({});
        setChipValues([]);
        setInitialChipValues([]);
        setRegisteredAttribute({});
        setJustificationOpen(false);
        setModified(false);
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Submitted");
        closeDialog();
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleSelectABCChange = (event) => {
    setAbcIndicator((prevObject) => ({
      ...prevObject,
      abcIndicatorFutureValue: event?.target?.value,
    }));
  };

  //    console.log(Object.keys(attributeValue) , Object.keys(uomValue), totalUomValues)

  const handleChangeTop = (event) => {
    if (event?.target?.name === "manufacturer") {
      // event.target.value = event.target.value;
      setCheckPart((prevObject) => ({
        ...prevObject,
        manufacturer: event?.target?.value,
      }));
    }
    if (event?.target?.name === "manufacturingPartNumber") {
      setCheckPart((prevObject) => ({
        ...prevObject,
        manufacturing_part_number: event?.target?.value,
      }));
    }
    if (event?.target?.name === "supplierPartNumber") {
      setCheckPart((prevObject) => ({
        ...prevObject,
        supplier_part_number: event?.target?.value,
      }));
    }
  };

  const ButtonFamily = ({ btnText }) => {
    return (
      <>
        {/* <button
                    type="submit"
                    className="submitButton"
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        position: "relative",
                        fontFamily: "Verdana",
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        handleApproveRequest()
                    }}
                >
                    {btnText}
                </button> */}

        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            fontFamily: "Verdana",
            background: isEnabled ? "#C6003D" : "#f5f5f5",
            cursor: isEnabled ? "pointer" : "default",
            color: isEnabled ? "#FFFFFF" : "#C6003D",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!ownerComment.trim()) {
              toast.error(
                `Please enter a comment before ${showSubmitOnly ? "submitting" : "approving"}.`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 800,
                },
              );
              return;
            }
            if (showSubmitOnly) {
              handleSubmitRequest();
            } else {
              handleApproveRequest();
            }
          }}
          disabled={!isEnabled || loading}
        >
          {loading ? "Processing.." : btnText}
        </button>
        {!showSubmitOnly && (
          <>
            <button
              type="submit"
              className="submitButton"
              style={{
                fontSize: 16,
                fontFamily: "Verdana",
                background: isEnabled ? "#C6003D" : "#f5f5f5",
                cursor: isEnabled ? "pointer" : "default",
                color: isEnabled ? "#FFFFFF" : "#C6003D",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (!ownerComment.trim()) {
                  toast.error("Please enter a comment before rework.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 800,
                  });
                  return;
                }
                handleReworkRequest();
              }}
              disabled={!isEnabled || loading || loadingReject || loadingRework}
            >
              {loadingRework ? <div>Loading...</div> : "Rework"}
            </button>
            <button
              type="submit"
              className="submitButton"
              style={{
                fontSize: 16,
                cursor: isEnabled ? "pointer" : "default",
                // position: "relative",
                fontFamily: "Verdana",
                background: isEnabled ? "#C6003D" : "#f5f5f5",
                color: isEnabled ? "#FFFFFF" : "#C6003D",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (!ownerComment.trim()) {
                  toast.error("Please enter a comment before rejecting.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 800,
                  });
                  return;
                }
                handleRejectRequest();
              }}
              disabled={!isEnabled || loading || loadingReject || loadingRework}
            >
              {loadingReject ? (
                // Render loader or loading state here
                <div>Loading...</div>
              ) : (
                // Render button text
                "Reject"
              )}
            </button>
          </>
        )}
        <button
          type="submit"
          className="cancelButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          Cancel
        </button>
      </>
    );
  };

  const handleInputChange = (index, value) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue != "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = numericValue;
      setInputValues(newInputValues);
      //   setEquipment_number_for_bom(newInputValues);
    }
    if (value === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = "";
      //   setEquipment_number_for_bom(newInputValues);
      setInputValues(newInputValues);
    }
  };

  const handleIndicatorSelectChange = (event) => {
    let val = event.target.checked ? "X" : "";
    setCriticalityIndicator(val);
  };

  const handleFutureValue = (event) => {
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: event?.target?.value,
      }));
    }
    if (event?.target?.name === "minimumValue") {
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumFutureValue: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumFutureValue: "",
        }));
      }
    }
    if (event?.target?.name === "maximumValue") {
      // if (parseInt(event?.target?.value, 10) < parseInt(minimumValue?.minimumFutureValue, 10)) {
      //     toast.error("Maximum Stock should be greater than Minimum Stock.", {
      //         position: toast.POSITION.TOP_CENTER,
      //         autoClose: 800,
      //     });
      // }
      if (
        parseInt(event?.target?.value, 10) <
          parseInt(minimumValue?.minimumFutureValue, 10) ||
        (parseInt(event?.target?.value, 10) === 0 &&
          parseInt(minimumValue?.minimumFutureValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumFutureValue: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumFutureValue: "",
        }));
      }
    }
    if (event?.target?.name === "maximumValueJustify") {
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "minimumValueJustify") {
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "abcIndicatorJustify") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "criticalityIndicator") {
      setCriticalityIndicator(event?.target?.value);
    }
    if (event?.target?.name === "sloc") {
      setSloc(event?.target?.value);
    }
    if (event?.target?.name === "bin") {
      if (event?.target?.value.length <= 10) {
        setBin(event?.target?.value);
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    }
  };

  // const ValueDisplay = ({ type, future, justification, justifyValue, futureValue }) => {
  //     return (
  //         <>
  //             <div style={{
  //                 display: "flex",
  //                 flexDirection: "row",
  //                 justifyContent: "space-evenly",
  //             }}>
  //                 {/* abcIndicator */}
  //                 {future && type === "abcIndicator" && (
  //                     <Tooltip title={abcIndicator?.abcIndicatorFutureValue || ""} placement="top">
  //                         <FormControl sx={{ width: "100px", margin: "12px 85px 8px 50px" }}>
  //                             <Select
  //                                 value={abcIndicator?.abcIndicatorFutureValue}
  //                                 onChange={handleSelectABCChange}
  //                                 IconComponent={() => (
  //                                     <DropdownIcon
  //                                         style={{
  //                                             width: "20px",
  //                                             position: "relative",
  //                                             left: "-10px",
  //                                         }}
  //                                     />
  //                                 )}
  //                                 sx={{ height: "32px" }}
  //                             >
  //                                 {ABCoptions.map((option) => (
  //                                     <MenuItem key={option} value={option}>
  //                                         {option}
  //                                     </MenuItem>
  //                                 ))}
  //                             </Select>
  //                         </FormControl>
  //                     </Tooltip>
  //                 )}
  //                 {justification && type === "abcIndicator" && (
  //                     <input
  //                         autoComplete="off"
  //                         placeholder=" -"
  //                         name="abcIndicatorJustify"
  //                         onChange={handleFutureValue}
  //                         type="text"
  //                         value={abcIndicator?.abcIndicatorJustify}
  //                         className="partInputField"
  //                     />
  //                 )}

  //                 {/* criticalIndicator */}
  //                 {future && type === "criticalityIndicator" && (
  //                     <FormControl sx={{
  //                         borderRadius: "8px",
  //                         margin: "10px 85px 10px 50px !important",
  //                         width: "100px",
  //                         outlineStyle: "none",
  //                         border: "1px solid #cbc3c3",
  //                         textAlign: "center"
  //                     }}>
  //                         <Select
  //                             value={criticalityIndicator}
  //                             onChange={handleIndicatorSelectChange}
  //                             renderValue={(selected) => (
  //                                 <div>
  //                                     <span key={selected}>{selected}</span>
  //                                 </div>
  //                             )}
  //                             sx={{
  //                                 padding: "0px !important",
  //                                 height: "32px"
  //                             }}
  //                         >
  //                             <MenuItem value="">
  //                                 <Checkbox checked={criticalityIndicator === ""} />
  //                                 <ListItemText primary="Blank" />
  //                             </MenuItem>
  //                             <MenuItem value="X">
  //                                 <Checkbox checked={criticalityIndicator === "X"} />
  //                                 <ListItemText primary="X" />
  //                             </MenuItem>
  //                         </Select>
  //                     </FormControl>
  //                 )}

  //                 {/* minimum stock */}
  //                 {future && type === "minimumStock" && (
  //                     <input
  //                         //placeholder="future Value"
  //                         name="minimumValue"
  //                         type="text" // Change type to text
  //                         pattern="[0-9]*"
  //                         inputmode="numeric"
  //                         className="narrow_input partInputFieldEq"
  //                         autoComplete="off"
  //                         value={minimumValue?.minimumFutureValue}
  //                         onChange={handleFutureValue}
  //                     />
  //                 )}
  //                 {justification && type === "minimumStock" && (
  //                     <input
  //                         autoComplete="off"
  //                         placeholder=" -"
  //                         name="minimumValueJustify"
  //                         onChange={handleFutureValue}
  //                         type="text"
  //                         value={minimumValue?.minimumValueJustify}
  //                         className="partInputField"
  //                     />
  //                 )}
  //                 {/* maximum stock */}
  //                 {future && type === "maximumStock" && (
  //                     <input
  //                         //placeholder="future Value"
  //                         name="maximumValue"
  //                         type="text" // Change type to text
  //                         pattern="[0-9]*"
  //                         inputmode="numeric"
  //                         className="narrow_input partInputFieldEq "
  //                         value={maximumValue?.maximumFutureValue}
  //                         onChange={handleFutureValue}
  //                         autoComplete="off"
  //                     />
  //                 )}
  //                 {justification && type === "maximumStock" && (
  //                     <input
  //                         autoComplete="off"
  //                         placeholder=" -"
  //                         name="maximumValueJustify"
  //                         onChange={handleFutureValue}
  //                         type="text"
  //                         value={maximumValue?.maximumValueJustify}
  //                         className="partInputField"
  //                     //  disabled={!minFutCurrValueChanged}
  //                     />
  //                 )}
  //                 {/* storage location */}
  //                 {future && type === "storageLocation" && (
  //                     <input
  //                         //placeholder="future Value"
  //                         name="sloc"
  //                         type="text"
  //                         className="narrow_input"
  //                         value={sloc}
  //                         onChange={handleFutureValue}
  //                         autoComplete="off"
  //                     />
  //                 )}

  //                 {/* bin */}
  //                 {future && type === "bin" && (
  //                     <input
  //                         //placeholder="future Value"
  //                         name="bin"
  //                         type="text"
  //                         className="narrow_input"
  //                         value={bin}
  //                         autoComplete="off"
  //                         onChange={handleFutureValue}
  //                     />
  //                 )}

  //             </div>
  //         </>
  //     )
  // }

  const showInformation = () => {
    return (
      <>
        <div
          style={{
            height: "540px",
            width: "500px",
            position: "relative",
            top: "-20px",
            left: "-56px",
          }}
        >
          <MatrixCriteria />
        </div>
      </>
    );
  };

  const MaterialCardData = () => {
    const cardData = { ...dialogData?.attribute_data };

    const cardDataValue = Object.entries(cardData);
    const middleIndex = Math.ceil(cardDataValue.length / 2);
    const materialNumberDetailsFirstRow = cardDataValue.slice(0, middleIndex);
    const materialNumberDetailsSecondRow = cardDataValue.slice(middleIndex);

    return (
      <>
        {/* <div style={{
                    display: "flex",
                    margin: "10px",
                    borderRadius: "4px",
                }}>
                    <div className="row">
                        {materialNumberDetailsFirstRow.map(([element, value], index) => (
                            <>
                                <div className="rowelement" >
                                    <div key={index} className="elementHeading">
                                        {element} :-
                                    </div>
                                    <div key={index} className="element">
                                        {value ? value : '--'}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                    <div className="row">
                        {materialNumberDetailsSecondRow.map(([element, value], index) => (
                            <>
                                <div className="rowelement" >
                                    <div key={index} className="elementHeading">
                                        {element} :-
                                    </div>
                                    <div key={index} className="element">
                                        {value ? value : '--'}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {attributes.map((attribute) => (
            <div
              key={attribute}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                width: "48%",
                margin: "0px 10px",
              }}
            >
              <Typography style={headingStyleAttribute} sx={{ width: "250px" }}>
                {renderStyledAttribute(attribute)}
              </Typography>
              <Typography
                sx={{
                  margin:
                    uomValues[attribute].length > 0 ? "0px 0px 0px 0px " : null,
                }}
              >
                :-
              </Typography>
              {typeAttributeValue[attribute] === "string" ? (
                <>
                  <div style={{ position: "relative" }}>
                    <>
                      <Autocomplete
                        sx={{
                          height: "32px",
                          borderRadius: "4px",
                          width:
                            uomValues[attribute].length > 0 ? "120px" : "200px",
                          background: "#FFFFFF",
                          left:
                            uomValues[attribute].length > 0 ? "25px" : "0px",
                          margin:
                            uomValues[attribute].length > 0
                              ? "10px 0px 10px 22px"
                              : "10px 30px",
                        }}
                        popupIcon={
                          <DropdownIcon
                            style={{
                              width: "20px",
                              position: "relative",
                              left: "0px",
                            }}
                          />
                        }
                        id="combo-box-demo-sap"
                        value={attributeValue[attribute] || ""}
                        onChange={(e, value) => {
                          handleChange(e, attribute, value);
                        }}
                        options={attributeValues[attribute] || []}
                        disableClearable={
                          attributeValue[attribute] ? false : true
                        } // Enable clear functionality
                        renderInput={(params) => (
                          <TextField
                            className="formControlSelect"
                            placeholder="Select Modifier"
                            {...params}
                            variant="outlined"
                          />
                        )}
                        clearIcon={
                          <ClearIcon
                            style={{
                              position: "relative",
                              top: "0px",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                        }
                      />
                    </>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ position: "relative" }}>
                    <input
                      placeholder="Enter Value"
                      name={attribute}
                      type="text" // Change type to text
                      pattern="[0-9,/.\\-\s ]*"
                      inputmode="numeric"
                      className="uomInputValue"
                      autoComplete="off"
                      onChange={(event) =>
                        handleAttributeChange(
                          attribute,
                          event.target.value,
                          "nonSelect",
                        )
                      }
                      value={attributeTypeValue[attribute] || ""}
                      style={{
                        // left:
                        //   uomValues[attribute].length > 0
                        //     ? "10px"
                        //     : "0px",
                        // margin:
                        //   uomValues[attribute].length > 0
                        //     ? "10px 0px 10px 22px "
                        //     : "10px 30px",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        margin: "10px 110px 10px 32px",
                        height: "32px",
                        width: "120px",
                        position: "relative",
                        top: "-2px",
                        outlineStyle: "none",
                        border: "1px solid #cbc3c3",
                      }}
                    />
                    {uomValues[attribute].length > 0 && (
                      <>
                        <div>
                          <Typography
                            style={{
                              fontFamily: "Verdana",
                              // background: "#EFEFEF",
                              fontSize: "13px",
                              position: "absolute",
                              top: "-16px",
                              right: "60px",
                              fontWeight: "560",
                            }}
                          >
                            UOM{" "}
                            {attributeTypeValue[attribute] && (
                              <span
                                style={{ color: "#C6003D", fontSize: "14px" }}
                              >
                                *
                              </span>
                            )}
                          </Typography>
                          <Select
                            displayEmpty
                            sx={{
                              height: "32px",
                              borderRadius: "4px",
                              width: "80.2px",
                              background: "#FFFFFF",
                              margin: "10px 0px",
                              right: "28px",
                              top: "-2px",
                              position: "absolute",
                            }}
                            value={attributeTypeValue[attribute + "UOM"] || ""}
                            onChange={(event) =>
                              handleAttributeChange(
                                attribute,
                                event.target.value,
                                "UOMChange",
                              )
                            }
                            inputProps={{
                              "aria-label": "Without label",
                            }}
                            input={<OutlinedInput />}
                            IconComponent={() => (
                              <DropdownIcon
                                style={{
                                  width: "20px",
                                  position: "relative",
                                  left: "-10px",
                                }}
                              />
                            )}
                            MenuProps={uomProps}
                            disabled={!attributeTypeValue[attribute]}
                          >
                            <MenuItem disabled value="">
                              <span
                                style={{
                                  color: "#333333",
                                }}
                              >
                                Select
                              </span>
                            </MenuItem>
                            {uomValues[attribute]?.map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </>
    );
  };

  const handleSelectChange = (event) => {
    setCurrency(event?.target?.value);
  };

  const handlechipsValues = (values) => {
    // Group by Attribute_Order
    const attributeData = attributes
      .map((attrName, index) => {
        const matchedAttr = Array.isArray(attributesObj)
          ? attributesObj.find((item) => item.attribute_name === attrName)
          : null;

        return {
          name: attrName,
          value: attributeValue[attrName],
          unit: uomValue[attrName] || "",
          attributeOrder: matchedAttr?.attribute_order || index + 1, // Replace with actual order if available from backend
          groupOrder: matchedAttr?.group_order || index + 1, // Replace with actual group order if available
        };
      })
      .filter((attr) => attr.value); // ✅ Filter out empty values;

    const groupedByAttributeOrder = attributeData.reduce((acc, attr) => {
      const key = attr.attributeOrder;
      if (!acc[key]) acc[key] = [];
      acc[key].push(attr);
      return acc;
    }, {});

    const sortedOrders = Object.keys(groupedByAttributeOrder).sort(
      (a, b) => a - b,
    );
    const attributeParts = sortedOrders
      .map((order) => {
        const group = groupedByAttributeOrder[order]; // Group by Group_Order

        const groupedByGroupOrder = group.reduce((acc, item) => {
          const key = item.attributeOrder;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        const groupParts = Object.values(groupedByGroupOrder).map(
          (groupItems) => {
            if (groupItems.length === 1) {
              // Only one value in this group
              return `${groupItems[0].value}${groupItems[0].unit || ""}`;
            } else {
              // Multiple values in same groupOrder → combine with "*", append unit once
              const values = groupItems.map((i) => i.value).join("x");
              const unit = groupItems[0].unit || "";
              return `${values}${unit}`;
            }
          },
        );

        return groupParts.join("x");
      })
      .filter(Boolean); // ✅ Remove empty strings;
    let description = attributeDetails[0]?.noun_abbreviation;
    if (
      attributeDetails[0]?.modifier_abbreviation &&
      attributeDetails[0]?.modifier_abbreviation !== "ANY"
    )
      description += `,${attributeDetails[0]?.modifier_abbreviation}`;
    description += `:${attributeParts.join(",")}`;

    if (description.length > 39) {
      description = description.slice(0, 39) + ">";
    }

    return description;
  };

  const handleChangePirData = (event) => {
    if (event?.target?.name === "vendorNumber") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          vendor_account: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          vendor_account: "",
        }));
      }
    }
    if (event?.target?.name === "supplierPartNumber") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        supplier_part_number: event?.target?.value,
      }));
    }
    if (event?.target?.name === "leadTime") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          lead_time_from_pir: "",
        }));
      }
    }
    if (event?.target?.name === "netPrice") {
      const isValid = /^[0-9,/.\\-\s]*$/.test(event?.target?.value);
      if (isValid) {
        setModified(true);
        const numericValue = parseInt(event?.target?.value, 10);
        if (!isNaN(numericValue) && numericValue != "") {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            standard_price: event?.target?.value,
          }));
        }
        if (event?.target?.value === "") {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            standard_price: "",
          }));
        }
        if (parseInt(event?.target?.value) > 15) {
          setPirDataValue((prevObject) => ({
            ...prevObject,
            justification_for_net_price_change: "",
          }));
        }
      }
    }
    if (event?.target?.name === "orderUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        order_uom: event?.target?.value,
      }));
    }
    if (event?.target?.name === "baseUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
    }
    if (event?.target?.name === "predictedUsage") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          predticed_usage: numericValue,
        }));
      }
      if (event?.target?.value === "") {
        setPirDataValue((prevObject) => ({
          ...prevObject,
          predticed_usage: "",
        }));
      }
    }
    if (event?.target?.name === "enterJustification") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        justification_for_net_price_change: event?.target?.value,
      }));
    }
    if (event?.target?.name === "baseUOM") {
      setPirDataValue((prevObject) => ({
        ...prevObject,
        base_uom: event?.target?.value,
      }));
    }
  };
  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: "1400px",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="dialogHeading">
            {/* <PartCreation style={{ height: "60px" }} onClick={handleClose} /> */}
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              Part Creation Request
            </Typography>
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "18px",
                fontWeight: "600",
                // background: "#EFEFEF",
                padding: "6px",
                borderRadius: "4px",
              }}
            >
              Requested ID-{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginLeft: "10px",
                }}
              >
                #{partRequestNumber}
              </span>
            </Typography>
          </div>
          <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
        </DialogTitle>
        <DialogContent sx={{ width: "1260px", margin: "10px" }}>
          {dialogLoading ? (
            <>
              <Box sx={{ display: "flex" }}>
                <CircularProgress style={{ color: "#C6003D" }} />
              </Box>
            </>
          ) : (
            <DialogContentText>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "20px",
                  justifyContent: "space-around",
                }}
              >
                <div className="headers">
                  {/* <Plant /> */}
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>
                      Creation Required For Plant
                    </Typography>
                    <Typography>{dialogData?.plant_name || "-"}</Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <User /> */}
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>Submitted By</Typography>
                    <Typography>{dialogData?.submitted_by || "-"}</Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <Date /> */}
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>
                      Date of Submission
                    </Typography>
                    <Typography>
                      {dialogData?.date_of_submission || "-"}
                    </Typography>
                  </div>
                </div>
              </div>
              <Divider style={{ margin: "20px 0px", background: "#EFEFEF" }} />
              {/* <div className="formikExtension" style={{ width: "60%", justifyContent: "space-around" }}>
                                <div style={inputStyle}>
                                    <Typography style={headingStyle}>Manufacturer</Typography>
                                    <Typography style={{ margin: "4px 0px" }}>{dialogData?.vendor_account}</Typography>
                                </div>
                                <div style={inputStyle}>
                                    <Typography style={headingStyle}>Manufacturer Part Number</Typography>
                                    <Typography style={{ margin: "4px 0px" }}>{dialogData?.supplier_part_number}</Typography>
                                </div>
                                <div style={inputStyle}>
                                    <Typography style={headingStyle}>Vendort Part Number</Typography>
                                    <Typography style={{ margin: "4px 0px" }}>{dialogData?.lead_time_from_pir}</Typography>
                                </div>
                            </div>

                            <Paper sx={{
                                width: "100%",
                                // height: "200px",
                                // display: "flex",
                                // alignItems: "center",
                                margin: "20px 0px",
                                paddingBottom: "40px",
                                borderRadius: "18px"
                            }}>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}>
                                    <Typography sx={{
                                        fontFamily: "Verdana",
                                        fontSize: "24px",
                                        fontWeight: 400,
                                        padding: "30px"
                                    }}>
                                        Decision Matrix
                                    </Typography>
                                    <Tooltip disableFocusListener disableTouchListener placement="top-end" title={showInformation()}>
                                        <IconButton><Info /></IconButton>
                                    </Tooltip>
                                </div>
                                <Divider />
                                <div className='checkDecisionPart' style={{
                                    padding: "20px 0px"
                                }}>
                                    <Paper elevation={2} sx={{
                                        width: "120px",
                                        height: "100px",
                                        borderBottom: "2px solid red"
                                    }}>
                                        <Typography style={headingStyle} sx={{textAlign:"center", padding: "10px"}}>Impact</Typography>
                                        <Divider />
                                        <Typography style={headingStyle} sx={{textAlign:"center", padding: "10px"}}>3</Typography>
                                    </Paper>
                                    <Paper elevation={2} sx={{
                                        width: "120px",
                                        height: "100px",
                                        borderBottom: "2px solid red"
                                    }}>
                                        <Typography style={headingStyle} sx={{textAlign:"center", padding: "10px"}}>Probability</Typography>
                                        <Divider />
                                        <Typography style={headingStyle} sx={{textAlign:"center", padding: "10px"}}>4</Typography>
                                    </Paper>
                                    <div>
                                        <Typography style={headingStyle}>Stock Decision</Typography>
                                        <Typography className="checkbutton" style={{ top: "0px" }}>
                                            stockValue
                                        </Typography>
                                    </div>
                                </div>
                            </Paper> */}
              <div
                className="formikExtension"
                style={{ width: "100%", justifyContent: "space-around" }}
              >
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Manufacturer</Typography>
                  {/* <Typography style={{ margin: "4px 0px" }}>
                                        {dialogData?.manufacturer || "-"}
                                    </Typography> */}
                  <input
                    value={checkPart?.manufacturer}
                    //placeholder="Manufacturer"
                    style={{ backgroundColor: "#FFFFFF !important" }}
                    autoComplete="off"
                    type="text"
                    name="manufacturer"
                    onChange={handleChangeTop}
                    className="partInputFieldCreation"
                  />
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    Manufacturer Part Number
                  </Typography>
                  <input
                    value={checkPart?.manufacturing_part_number}
                    //placeholder="manufacturing part number"
                    type="text"
                    name="manufacturingPartNumber"
                    onChange={handleChangeTop}
                    autoComplete="off"
                    className="partInputFieldCreation"
                  />
                  {/* <Typography style={{ margin: "4px 0px" }}>
                                        {dialogData?.manufacturing_part_number || "-"}
                                    </Typography> */}
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    Vendort Part Number
                  </Typography>
                  <input
                    value={checkPart?.supplier_part_number}
                    //placeholder="Vendort Part Number"
                    type="text"
                    autoComplete="off"
                    name="supplierPartNumber"
                    onChange={handleChangeTop}
                    className="partInputFieldCreation"
                  />
                  {/* <Typography style={{ margin: "4px 0px" }}>
                                        {dialogData?.supplier_part_number || "-"}
                                    </Typography> */}
                </div>
              </div>
              <div>
                <DecisionMatrixDataOwner
                  setDecisionData={setDecisionData}
                  dialogData={dialogData}
                />
              </div>
              <div style={{ margin: "10px" }}>
                {/* Top Row: Material Group Label + ComboBox + Material Group Value */}
                <Typography
                  sx={{
                    fontFamily: "Verdana",
                    fontSize: "24px",
                    fontWeight: 400,
                    paddingTop: "20px",
                  }}
                >
                  Material Basic Data
                </Typography>
                <div className="partDesc" style={{ paddingBottom: "20px" }}>
                  <div style={inputStyle} className="selectComponent">
                    <Typography style={headingStyle}>
                      Noun{" "}
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "14px",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={dialogData?.noun_indentifier || ""}
                      // onChange={handleLeadTimeChange}
                      disabled
                      InputProps={{
                        sx: {
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "#f0f0f0", // Set the background color
                          color: "#000", // Set the text color
                          cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                          "&:hover": {
                            backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                          },
                          width: "fit-content",
                          paddingRight: "8px",
                        },
                      }}
                      fullWidth
                    />
                  </div>
                  <div style={inputStyle} className="selectComponent">
                    <Typography style={headingStyle}>Modifier </Typography>
                    <TextField
                      variant="outlined"
                      value={dialogData?.modifier || ""}
                      // onChange={handleLeadTimeChange}
                      disabled
                      InputProps={{
                        sx: {
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "#f0f0f0", // Set the background color
                          color: "#000", // Set the text color
                          cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                          "&:hover": {
                            backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                          },
                          width: "fit-content",
                          paddingRight: "8px",
                        },
                      }}
                      fullWidth
                    />
                  </div>

                  <div style={inputStyle} className="selectComponent">
                    <Typography style={headingStyle}>
                      Material Group{" "}
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "14px",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Autocomplete
                      popupIcon={
                        <DropdownIcon
                          style={{
                            width: "20px",
                            position: "relative",
                            left: "0px",
                          }}
                        />
                      }
                      id="combo-box-demo"
                      options={materialGroupOptions}
                      disableClearable={true}
                      value={materialgroup || null}
                      getOptionLabel={(option) =>
                        option?.material_group_description ||
                        option?.material_group ||
                        ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        String(option?.material_group ?? "")
                          .trim()
                          .toUpperCase() ===
                        String(value?.material_group ?? "")
                          .trim()
                          .toUpperCase()
                      }
                      onChange={(e, value) => {
                        setMaterialgroup(value);

                        setPartDescriptionData((prevValue) => ({
                          ...prevValue,
                          material_group: value?.material_group || "", // get value from selected object
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="formControlSelect"
                          placeholder="Select Material Group"
                          {...params}
                          variant="outlined"
                        />
                      )}
                    />
                  </div>
                  <div>
                    <Typography style={headingStyle}>
                      Material Group Number
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={
                        materialgroup?.material_group ||
                        dialogData?.material_group
                      }
                      disabled
                      InputProps={{
                        sx: {
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "#f0f0f0", // Set the background color
                          color: "#000", // Set the text color
                          cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                          "&:hover": {
                            backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                          },
                          width: "fit-content",
                          paddingRight: "8px",
                        },
                      }}
                      fullWidth
                    />
                  </div>
                </div>

                {/* Short Description */}
                <div style={{ marginTop: "20px" }}>
                  <Typography
                    style={headingStyle}
                    sx={{ color: "#212F37", fontSize: "18px" }}
                  >
                    Short Description
                  </Typography>
                  <Typography style={{ margin: "10px 0px" }}>
                    {dataModified
                      ? handlechipsValues(chipValues)
                      : dialogData?.clean_short_description}
                  </Typography>
                </div>

                {/* Data Attributes */}
                <div style={{ marginTop: "20px" }}>
                  <Typography
                    style={headingStyle}
                    sx={{ color: "#212F37", fontSize: "18px" }}
                  >
                    Data Attributes
                  </Typography>
                  <Typography style={{ margin: "10px 0px" }}>
                    {MaterialCardData()}
                  </Typography>
                </div>

                {/* Substitute Part */}
                <div style={{ marginTop: "20px" }}>
                  <Typography
                    style={headingStyle}
                    sx={{ color: "#212F37", fontSize: "18px" }}
                  >
                    Substitute Part
                  </Typography>
                  <Typography style={{ margin: "10px 0px" }}>
                    {dialogData?.substitution_status !== "no" ? (
                      "No Substitute Part Found"
                    ) : (
                      <OwnerSubstitutionData
                        checkTableData={checkTableData}
                        columnValues={columnValues}
                        maxRows={maxRows}
                        subStituLoading={subStituLoading}
                      />
                    )}
                  </Typography>
                </div>
              </div>

              <Divider style={{ background: "#EFEFEF", margin: "20px 0px" }} />
              <div
                className="formikExtension"
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "stretch",
                }}
              >
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    SAP Vendor Number
                  </Typography>
                  <Autocomplete
                    popupIcon={
                      <DropdownIcon
                        style={{
                          width: "20px",
                          position: "relative",
                          left: "0px",
                        }}
                      />
                    }
                    id="combo-box-demo-sap"
                    sx={{ margin: "10px" }}
                    options={vendorNames}
                    // disableClearable={true}
                    value={pirDataValue?.vendor_account}
                    onChange={(e, value) => {
                      handleVendorNameChange(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        className="formControlSelect"
                        placeholder="SAP Vendor Number"
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.vendor_account || "-"}</Typography> */}
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    Vendor Material Number
                  </Typography>
                  <input
                    value={pirDataValue?.supplier_part_number}
                    //placeholder="Vendort Part Number"
                    type="text"
                    autoComplete="off"
                    name="supplierPartNumber"
                    onChange={handleChangePirData}
                    className="partInputField"
                  />
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.supplier_part_number || "-"}</Typography> */}
                </div>
                <div style={inputStyle}>
                  <Typography
                    style={{
                      fontWeight: "700",
                      position: "relative",
                      right: "20px",
                    }}
                  >
                    Lead Time
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <input
                      value={pirDataValue?.lead_time_from_pir}
                      //placeholder="Net Price($)"
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="leadTime"
                      onChange={handleChangePirData}
                      autoComplete="off"
                      className="partInputField"
                      style={{ width: "80px" }}
                    />
                    <FormControl
                      sx={{
                        m: 1,
                        width: "105px",
                        position: "relative",
                        left: "-10px",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        value={"Days"}
                        // onChange={handleLeadTimeChange}
                        disabled
                        InputProps={{
                          sx: {
                            height: "32px",
                            borderRadius: "8px",
                            backgroundColor: "#f0f0f0", // Set the background color
                            color: "#000", // Set the text color
                            cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                            "&:hover": {
                              backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                            },
                            width: "68px",
                          },
                        }}
                        fullWidth
                      />
                    </FormControl>
                  </div>
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.lead_time_from_pir || "-"}</Typography> */}
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Base UOM</Typography>
                  <FormControl sx={{ m: 1, width: "100px" }}>
                    <Select
                      value={pirDataValue?.base_uom}
                      name="baseUOM"
                      onChange={handleChangePirData}
                      IconComponent={() => (
                        <DropdownIcon
                          style={{
                            width: "30px",
                            position: "relative",
                            left: "-10px",
                          }}
                        />
                      )}
                      MenuProps={MenuProps}
                      sx={{ height: "32px", borderRadius: "8px" }}
                    >
                      {uomOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Order UOM</Typography>
                  <FormControl sx={{ m: 1, width: "100px" }}>
                    <Select
                      value={pirDataValue?.order_uom}
                      name="orderUOM"
                      onChange={handleChangePirData}
                      IconComponent={() => (
                        <DropdownIcon
                          style={{
                            width: "30px",
                            position: "relative",
                            left: "-10px",
                          }}
                        />
                      )}
                      MenuProps={MenuProps}
                      sx={{ height: "32px", borderRadius: "8px" }}
                    >
                      {uomOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.order_uom || "-"}</Typography> */}
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Conversion</Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <input
                      value={conversionValue?.base_unit}
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="conversionBase"
                      onChange={handleConversionChange}
                      autoComplete="off"
                      className="conversionInputField"
                    />
                    <Typography className="conversionValue">
                      {pirDataValue?.base_uom}
                    </Typography>
                    <Typography className="conversionEqual">==</Typography>
                    <input
                      value={conversionValue?.order_unit}
                      autoComplete="off"
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="conversionOrder"
                      onChange={handleConversionChange}
                      className="conversionInputField"
                    />
                    <Typography className="conversionValue">
                      {pirDataValue?.order_uom}
                    </Typography>
                  </div>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    Annual Predicted Usage
                  </Typography>
                  <input
                    value={pirDataValue?.predticed_usage}
                    //placeholder="Net Price($)"
                    type="text" // Change type to text
                    pattern="[0-9]*"
                    inputmode="numeric"
                    autoComplete="off"
                    name="predictedUsage"
                    onChange={handleChangePirData}
                    className="partInputField"
                    style={{ width: "190px" }}
                  />
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.predticed_usage || "-"}</Typography> */}
                </div>
                <div style={inputStyle}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Typography style={{ ...headingStyle, margin: "0px 10px" }}>
                      {" "}
                      Price Unit
                    </Typography>
                    <Typography style={headingStyle}> Price UOM</Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <input
                      value={pirDataValue?.standard_price}
                      //placeholder="Net Price($)"
                      type="text" // Change type to text
                      pattern="[0-9,/.\\-\s]*"
                      inputmode="numeric"
                      name="netPrice"
                      autoComplete="off"
                      onChange={handleChangePirData}
                      className="partInputField"
                      style={{ width: "80px" }}
                    />
                    <FormControl
                      sx={{
                        m: 1,
                        width: "70px",
                        position: "relative",
                        left: "-10px",
                      }}
                    >
                      <Select
                        value={currency}
                        onChange={handleSelectChange}
                        IconComponent={() => (
                          <DropdownIcon
                            style={{
                              width: "40px",
                              position: "relative",
                              left: "-10px",
                            }}
                          />
                        )}
                        sx={{
                          height: "32px",
                          borderRadius: "8px",
                          width: "100px",
                        }}
                      >
                        {options.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.standard_price + " " + dialogData?.currency || "-"}</Typography> */}
                </div>
                {pirDataValue?.standard_price <= 15 &&
                  pirDataValue?.standard_price !== "" && (
                    <div style={inputStyle}>
                      <Typography style={headingStyle}>
                        Price UOM Comment
                      </Typography>
                      <Typography>
                        {pirDataValue?.justification_for_net_price_change}
                      </Typography>
                      {/* <Typography style={{ margin: "4px 0px" }}>{dialogData?.supplier_part_number || "-"}</Typography> */}
                    </div>
                  )}
              </div>
              <Divider style={{ background: "#EFEFEF", margin: "20px 0px" }} />
              <div className="creationHeading">
                <Typography
                  style={{
                    color: "black",
                    fontWeight: 600,
                    marginLeft: "20px",
                  }}
                >
                  Proposed Value
                </Typography>
                <Typography style={{ color: "black", fontWeight: 600 }}>
                  Reason for Change
                </Typography>
              </div>
              {/* <div className="valueDisplay">
                                <Typography className="subHeading">ABC Indicator</Typography>
                                <ValueDisplay
                                    type="abcIndicator"
                                    future={true}
                                    justification={true}
                                    justifyValue={dialogData?.justification_for_change_in_abc_indicator ? dialogData?.justification_for_change_in_abc_indicator : "-"}
                                    futureValue={dialogData?.ABC_indicator ? dialogData?.ABC_indicator : "-"}
                                />
                            </div>
                            <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
                            <div className="valueDisplay">
                                <Typography className="subHeading">Criticality Indicator</Typography>
                                <ValueDisplay
                                    type="criticalityIndicator"
                                    future={true}
                                    justification={false}
                                    futureValue={dialogData?.critical_part ? dialogData?.critical_part : "-"}
                                />
                            </div>
                            <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
                            <div className="valueDisplay">
                                <Typography className="subHeading">Minimum Stock</Typography>
                                <ValueDisplay
                                    type="minimumStock"
                                    future={true}
                                    justification={true}
                                    justifyValue={dialogData?.justification_for_change_in_minimum_stock ? dialogData?.justification_for_change_in_minimum_stock : "-"}
                                    futureValue={dialogData?.minimum_stock_level ? dialogData?.minimum_stock_level : "-"}
                                />
                            </div>
                            <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
                            <div className="valueDisplay">
                                <Typography className="subHeading">Maximum Stock</Typography>
                                <ValueDisplay
                                    type="maximumStock"
                                    future={true}
                                    justification={true}
                                    justifyValue={dialogData?.justification_for_change_in_maximum_stock ? dialogData?.justification_for_change_in_maximum_stock : "-"}
                                    futureValue={dialogData?.maximum_stock_level ? dialogData?.maximum_stock_level : "-"}
                                />
                            </div>
                            <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
                            <div className="valueDisplay">
                                <Typography className="subHeading">Storage Location</Typography>
                                <ValueDisplay
                                    type="storageLocation"
                                    future={true}
                                    justification={false}
                                    futureValue={dialogData?.storage_location ? dialogData?.storage_location : "-"}
                                />
                            </div>
                            <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
                            <div className="valueDisplay">
                                <Typography className="subHeading">Bin</Typography>
                                <ValueDisplay
                                    type="bin"
                                    future={true}
                                    justification={false}
                                    futureValue={dialogData?.storage_bin ? dialogData?.storage_bin : "-"}
                                />
                            </div> */}
              <div className="valueDisplay">
                <Typography className="subHeading"></Typography>
              </div>
              <div className="valueDisplay">
                <Typography className="subHeading">ABC Indicator</Typography>
                <Tooltip
                  title={abcIndicator?.abcIndicatorFutureValue || ""}
                  placement="top"
                >
                  <FormControl
                    sx={{ width: "100px", margin: "12px 85px 8px 50px" }}
                  >
                    <Select
                      value={abcIndicator?.abcIndicatorFutureValue}
                      onChange={handleSelectABCChange}
                      IconComponent={() => (
                        <DropdownIcon
                          style={{
                            width: "20px",
                            position: "relative",
                            left: "-10px",
                          }}
                        />
                      )}
                      sx={{ height: "32px" }}
                    >
                      {ABCoptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Tooltip>

                <input
                  autoComplete="off"
                  placeholder=" -"
                  name="abcIndicatorJustify"
                  onChange={handleFutureValue}
                  type="text"
                  value={abcIndicator?.abcIndicatorJustify}
                  className="partInputField"
                />
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">
                  Criticality Indicator
                </Typography>
                {/* 
                                <FormControl sx={{
                                    borderRadius: "8px",
                                    margin: "10px 85px 10px 50px !important",
                                    width: "100px",
                                    outlineStyle: "none",
                                    border: "1px solid #cbc3c3",
                                    textAlign: "center"
                                }}>
                                    <Select
                                        value={criticalityIndicator}
                                        onChange={handleIndicatorSelectChange}
                                        renderValue={(selected) => (
                                            <div>
                                                <span key={selected}>{selected}</span>
                                            </div>
                                        )}
                                        sx={{
                                            padding: "0px !important",
                                            height: "32px"
                                        }}
                                    >
                                        <MenuItem value="">
                                            <Checkbox checked={criticalityIndicator === ""} />
                                            <ListItemText primary="Blank" />
                                        </MenuItem>
                                        <MenuItem value="X">
                                            <Checkbox checked={criticalityIndicator === "X"} />
                                            <ListItemText primary="X" />
                                        </MenuItem>
                                    </Select>
                                </FormControl> */}
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={criticalityIndicator === "X"}
                        style={{
                          color: "#575555",
                          position: "relative",
                          left: "90px",
                        }}
                        onChange={handleIndicatorSelectChange}
                      />
                    }
                    // label="My Checkbox"
                  />
                </FormGroup>
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Minimum Stock</Typography>
                <input
                  //placeholder="future Value"
                  name="minimumValue"
                  type="text" // Change type to text
                  pattern="[0-9]*"
                  inputmode="numeric"
                  className="narrow_input partInputFieldEq"
                  autoComplete="off"
                  value={minimumValue?.minimumFutureValue}
                  onChange={handleFutureValue}
                />
                <input
                  autoComplete="off"
                  placeholder=" -"
                  name="minimumValueJustify"
                  onChange={handleFutureValue}
                  type="text"
                  value={minimumValue?.minimumValueJustify}
                  className="partInputField"
                />
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Maximum Stock</Typography>
                <input
                  //placeholder="future Value"
                  name="maximumValue"
                  type="text" // Change type to text
                  pattern="[0-9]*"
                  inputmode="numeric"
                  className="narrow_input partInputFieldEq "
                  value={maximumValue?.maximumFutureValue}
                  onChange={handleFutureValue}
                  autoComplete="off"
                />
                <input
                  autoComplete="off"
                  placeholder=" -"
                  name="maximumValueJustify"
                  onChange={handleFutureValue}
                  type="text"
                  value={maximumValue?.maximumValueJustify}
                  className="partInputField"
                  //  disabled={!minFutCurrValueChanged}
                />
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Storage Location</Typography>
                <input
                  //placeholder="future Value"
                  name="sloc"
                  type="text"
                  className="narrow_input"
                  value={sloc}
                  onChange={handleFutureValue}
                  autoComplete="off"
                />
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Bin</Typography>
                <input
                  //placeholder="future Value"
                  name="bin"
                  type="text"
                  className="narrow_input"
                  value={bin}
                  autoComplete="off"
                  onChange={handleFutureValue}
                />
              </div>
              <Divider style={{ background: "#EFEFEF", margin: "4px 0px" }} />
              <div>
                <Typography className="equipmentNumber">
                  Equipment Number(s) For BOM
                </Typography>
                <div>
                  {/* <div style={{ display: "flex", flexDirection: "column", width: "20%" }}>
                                        <Typography>
                                            {dialogData?.equipment_number_for_bom?.map((val, index) => (
                                                <React.Fragment key={index}>
                                                    {val}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </Typography>
                                    </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "20%",
                    }}
                  >
                    {Array.from({ length: inputCount }).map((_, index) => (
                      <input
                        key={index}
                        className="partInputFieldEq"
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        autoComplete="off"
                        value={inputValues[index]}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        minLength="0" // Change min to minLength
                        maxLength="10" // Assuming you want to limit the length of input
                      />
                    ))}
                  </div>
                  <IconButton onClick={handleAddInput} sx={{ height: "40px" }}>
                    <ButtonPlus />
                  </IconButton>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#212F37",
                }}
              >
                <Typography style={headingStyleComments}>
                  Comments
                  <span
                    style={{
                      color: "#C6003D",
                      margin: "4px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <textarea
                  id="yourTextarea"
                  name="yourTextarea"
                  placeholder="Enter Comments"
                  value={ownerComment}
                  style={{
                    width: "50%",
                    fontFamily: "Verdana", // Set the font family to Verdana
                    minHeight: "50px",
                  }}
                  onChange={(e) => setOwnerComment(e?.target?.value)}
                  className="partTextField"
                  rows={4}
                  cols={50}
                />
              </div>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            margin: "auto !important",
            // justifyContent: "flex-start !important",
          }}
        >
          <ButtonFamily btnText={showSubmitOnly ? "Submit" : "Approve"} />
        </DialogActions>
      </Dialog>
      <ToastContainer />
      <JustificationDialog
        open={justificationOpen}
        showButton={false}
        setJustificationOpen={setJustificationOpen}
        valueData={pirDataValue?.justification_for_net_price_change}
        setPirDataValue={setPirDataValue}
        pirDataValue={pirDataValue}
        handleContinue={handleContinue}
      />
    </>
  );
};

export default OwnerPartCreationDialog;
